export const translationsEC = {
  'es-EC': {
    country: 'urbanización',
    project: 'Proyecto',
    sign: 'Letrero',
    remodeled: 'Remodelado',
    toRemodel: 'A remodelar',
    garage: 'Parqueo',
    departament: 'Departamento',
    propertyTypes: {
      'Departamento Dúplex': 'Departamento Dúplex',
      'Departamento Estándar': 'Departamento Estándar',
      'Departamento Loft': 'Departamento Loft',
      'Departamento Monoambiente': 'Departamento Monoambiente',
      'Departamento Penthouse': 'Departamento Penthouse',
      'Departamento Piso': 'Departamento Piso',
      'Departamento SemiPiso': 'Departamento SemiPiso',
      'Departamento Triplex': 'Departamento Triplex',
      PH: 'PH',
      Casa: 'Casa',
      'Terrenos y Lotes': 'Terrenos y Lotes',
      Quinta: 'Quinta',
      Local: 'Local',
      Hotel: 'Hotel',
      Oficina: 'Oficina',
      Galpón: 'Galpón',
      'Camas Nauticas': 'Camas Nauticas',
      Edificio: 'Edificio',
      Campo: 'Campo',
      'Otros Inmuebles': 'Otros Inmuebles',
      'Casa Dúplex': 'Casa Dúple',
      'Fondo de comercio': 'Fondo de comercio',
      Cochera: 'Cochera',
      'Parcelas, Nichos y Bovedas': 'Parcelas, Nichos y Bovedas',
      'Casa Triplex': 'Casa Triplex',
      Chacra: 'Chacra',
      Consultorio: 'Consultorio',
      Deposito: 'Deposito',
    },
  },
};
